import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Transition from '../../components/Transition/Transition';
import React from 'react'
import {Fade, Button, Box, Typography, Stack, Grid, CircularProgress} from "@mui/material";
import {} from "@mui/material";
import {InstagramEmbed } from 'react-social-media-embed';
import WhatsappIcon from "@mui/icons-material/WhatsApp";
import { useNavigate, useParams } from "react-router-dom";
import {Chip} from '@mui/material';

import { Navigate } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { t } from 'i18next';






function Bios() 
{
  const { id } = useParams();
const { t: tGlobal } = useTranslation('global');
const { t: tBios } = useTranslation('bios');
    const [bios, setBios] = useState([]);
      const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

      const getBioFromJson = (id) => {
    return bios.find(bio => bio.id === id);
  };
      

      
    useEffect(() => {
    const fetchAllData = async () => {
      try {
        setLoading(true);
        
        // Fetch all data in parallel
        const [bioRes] = await Promise.all([
          fetch('/data/bio.json'),
        ]);

        const [bioData] = await Promise.all([
          bioRes.json(),
        ]);

      setBios(bioData);
        
        setError(null);
      } catch (err) {
        console.error('Error loading bio data:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, []);

  const bio = getBioFromJson(id);
  const navigate = useNavigate();
  // Handle loading and error states
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <Typography color="error">{tGlobal('Error loading data')}: {error}</Typography>
      </Box>
    );
  }

  if (!bio) {
    return <Navigate to="/Error" replace />;
  }
  return (
    
    <Stack direction="row" sx={{justifyContent:"center", minHeight:"65.5vh", backgroundColor:"background.main"}}>
      <Fade in={true} timeout={2000}>
        <Stack direction="column" height="100%" width={{lg:"75%", md:"95%", xs:"95%"}}>
        <Stack direciton="row" justifyContent="flex-start" fontSize={{lg:"24px", md:"20px", xs:"14px"}} marginTop={{lg: "4vh", md: '3vh', xs:"2vh"}}> 
              <NavLink onClick={() => navigate(-1)}style={{textUnderlineOffset:"0.5vh", color:"#000000", fontSize:"100%"}}class="backclass">{tGlobal("General.Back")}</NavLink>
           </Stack>
           <Grid container spacing={{lg:"30px", md:"30px", xs:"20px"}} marginTop={{lg: "1vh", md: '1vh', xs:"1vh"}} marginBottom={{lg: "2.5vh", md: '1vh', xs:"1vh"}}>
           <Grid item lg={4} md={6} xs={12}>
              
                  <Box component="img" sx={{height: "auto", display: 'block', width: "100%", overflow: 'hidden'}} src={"/image/bios/"+id+"/thumbnail.webp"} alt={bio.name}/>
            </Grid>
            <Grid item lg={8} md={6} xs={12}>
              <Typography  sx={{fontWeight:"400", color:"primary.darkred", marginBottom:{lg: "1.5vh", md: '2vh', xs:"2vh"}, fontSize:{lg:"56px", md: "48px", xs:"36px"}}}>{tBios(id+".name")}</Typography>
             <Stack direction={"row"} spacing={2}>
            
            { 
              bio.catergory.map((cat)=>
              {
                return (
                  <Chip  sx={{height:{lg:"4vh", md:"3vw"}, fontSize:{lg:"24px", md: "24px", xs:"18px"}}} label={tGlobal("Bios.catergory."+cat)} />
                )
              }

              )
                    

            }</Stack> 
            <Typography sx={{fontWeight:"400", color:"primary.black", marginBottom:{lg: "1.5vh", md: '2vh', xs:"2vh"}, fontSize:{lg:"24px", md: "24px", xs:"18px"}}}>{tBios(id+".description")}</Typography>
        </Grid>
           </Grid>
        </Stack>
      </Fade>
    </Stack>
  )
}export default Transition(Bios);


